'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  responderIds: (0, _immutable.List)()
}, 'SpecificTeamMembersAssignment');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/records/SpecificTeamMembersAssignment.js
// module id = 916
// module chunks = 2 3